import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { interval } from "rxjs";
import { LoginService } from "./layout/components/login-form/login-form.service";
import { MatBottomSheet } from '@angular/material/bottom-sheet';
@Component({
  selector: "app-root",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  ngOnInit() {
    this.sessionStorageFunction();
  }

  constructor(private loginService: LoginService, private router: Router, private bottomSheet: MatBottomSheet) { }
  authToken: any;
  userNames: string;
  userEmails: string;

  sessionStorageFunction() {
    // Checking the google credential in local storage in every one second
    let data = interval(1000).subscribe(() => {

      let flag = sessionStorage.getItem("goodleLoginCredential");
      if (flag) {
        //stopping the interval if credential found
        // data.unsubscribe();

        // Changing JSON token to object
        var base64Url = flag.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        let finalData = JSON.parse(jsonPayload);

        let user = {
          name: finalData["name"],
          email: finalData["email"],
          source: "Google",
        };
        // calling the our socialLogin api

        if ((!sessionStorage.getItem("goodleLoginCredential")) || !(sessionStorage.getItem("access_token")) && !sessionStorage.getItem('signupPage')) {
          this.loginService.postLoginSocial(user).subscribe(
            (response) => {
              if (response["status"] == true) {
                this.authToken = response.result.authToken;
                sessionStorage.setItem("access_token", this.authToken);
                this.userNames = response.result.userDetails.first_name;
                sessionStorage.setItem("userName", this.userNames);
                this.userEmails = response.result.userDetails.email;
                sessionStorage.setItem("email", this.userEmails);

                //navigating the user to aggregator page
                this.router.navigate(["/horizontal/food-menu"]);
                this.bottomSheet.dismiss();

              }
            },
            (err: any) => {
              console.log("google configuration error:", err);
            }
          );
        } else {
          data.unsubscribe();
        }

      }

      // checking if we get the access_token (from other way of login), then stopping the interval
      else if (sessionStorage.getItem("access_token")) {
        data.unsubscribe();
      } else {
      }
    });
  }
}
